<template>
  <div class="logo">
    <img alt="Simba Stickers logo" src="../assets/images/SimbaStickers_Logo.png"/>
  </div>

  <div class="welcome">
    <h1>Welcome to Simba Stickers!</h1>

    <p>
      We run an <a href="https://shop.simbastickers.com">online store</a>, at <a href="https://shop.simbastickers.com">shop.simbastickers.com</a>,
      in association with <a href="https://sellfy.com" aria-label="">Sellfy</a>.
    </p>
    <p>Before long there will be a dedicated storefront to that shop at this address, enabling for much easier searching
      of our vast catalogue of digital and print-on-demand products.</p>
    <p>Until then, we kindly invite you to shop directly from <a href="https://shop.simbastickers.com">shop.simbastickers.com</a>,
      which is fully functional.</p>
    <p>If you would like to be informed upon release of our website, kindly sign up for our newsletter on the <a
        href="https://shop.simbastickers.com"> store</a>!</p>
    <p class="go_to_store"><a href="https://shop.simbastickers.com">
      <span class="text">Go to <b>shop.simbastickers.com</b></span>
      <FontAwesomeIcon :icon="faArrowRightFromBracket"/>
    </a></p>
    <p class="redirect">You will be redirected in
      <Countdown :duration="durationBeforeRedirection" :callback="redirectToShop"/>
      seconds.
    </p>

  </div>
</template>

<script setup lang="ts">
import { defineComponent } from 'vue';
import Countdown from '@/components/Countdown.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'     ;
import { faHouse, faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons' ;

const durationBeforeRedirection = 1;
const redirectToShop = () => {
  console.info('Redirecting!');
  window.location.href = 'https://shop.simbastickers.com';
};
redirectToShop(); // We want to do it immediately.

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.logo {
  max-width: 100%;

  img {
    max-width: 50%;
  }
}

h3 {
  margin: 10px 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

p.go_to_store {
  display: flex;
  flex-direction: row;
  flex: 0 0 auto;
  justify-content: center;

  a {
    padding: 10px 10px;
    display: inline-flex;
    border: 1px solid #F999;
    border-radius: 5px;
  }

  .text {
    margin-right: 10px;
    b{
      display: inline-flex;
      padding-left: 5px;
      font-weight: bold;
    }
  }

  svg {
    height: 25px;
  }

}

@media (max-width: 600px) {
  .logo {

    img {
      max-width: 75%;
    }
  }

}

@media (min-width: 720px) and (max-width: 1280px) {
  .logo {

    img {
      max-width: 40%;
    }
  }

}
</style>
